var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-close position-absolute d-flex justify-content-end",class:_vm.getClasses(),on:{"click":_vm.emit}},[_c('img',{staticClass:"close-img",attrs:{"src":require(`@/assets/icons/close.png`),"width":"25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }